// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_xf74q","box":"index_box_9ONLY","close":"index_close_xJBkj","page":"index_page_huF4Q"};